module.exports = __webpack_public_path__ + "img/search2.18939727.svg";